import React from 'react';
import { Redirect } from 'react-router-dom';
import lazyLoad from 'utils/lazyLoad';

export const removeTrailingSlashes = str => str.replace(/(\/+)$/, '');

export function RemoveTrailingSlashRedirect({ location }) {
  return <Redirect to={removeTrailingSlashes(location.pathname)} />;
}

export const UnauthorizedPageAccess = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "UnauthorizedPageAccess" */ 'pages/UnauthorizedPageAccess'
    ),
);
